import type { Messages } from '@lingui/core';
import { isSupportedLocale, type SupportedLocale } from './locale';

const canonical = (value: unknown): string => {
  if (Array.isArray(value)) return `[${value.map(canonical).join(',')}]`;
  if (value !== null && typeof value === 'object') {
    return `{${Object.entries(value).sort(([a], [b]) => a.localeCompare(b)).map(([key, item]) => `${JSON.stringify(key)}:${canonical(item)}`).join(',')}}`;
  }
  return JSON.stringify(value);
};

export const mergeCatalogs = (modules: Record<string, Messages>): Record<SupportedLocale, Messages> => {
  const catalogs: Record<SupportedLocale, Messages> = { en: {}, 'zh-CN': {} };
  const domains: Record<SupportedLocale, Set<string>> = { en: new Set(), 'zh-CN': new Set() };
  for (const [path, messages] of Object.entries(modules)) {
    const match = /^\.\/locales\/([^/]+)\/([^/]+)\.po$/.exec(path);
    if (!match || !isSupportedLocale(match[1])) throw new Error(`Unsupported catalog path: ${path}`);
    const locale = match[1];
    const domain = match[2];
    domains[locale].add(domain);
    for (const [id, message] of Object.entries(messages)) {
      if (Object.hasOwn(catalogs[locale], id) && canonical(catalogs[locale][id]) !== canonical(message)) {
        throw new Error(`Conflicting catalog message: ${locale}:${id} (${path})`);
      }
      Object.defineProperty(catalogs[locale], id, { value: message, enumerable: true, configurable: true, writable: true });
    }
  }
  if (!domains.en.size || [...domains.en].sort().join(',') !== [...domains['zh-CN']].sort().join(',')) {
    throw new Error('Every locale must contain the same nonempty set of catalogs');
  }
  return catalogs;
};
